import { isBoolean } from 'lodash';

export interface OptionBuilderState {
  isArchivedChecked: boolean;
  isDefaultChecked: boolean;
  showAddNewModal: boolean;
}

export const OptionBuilderActionType = {
  resetAllValues: 0,
  editOption: 1,
  openAddNew: 2,
  updateDefaultProperty: 3,
  updateArchivedProperty: 4,
} as const;
export type OptionBuilderActionType = (typeof OptionBuilderActionType)[keyof typeof OptionBuilderActionType];

export interface OptionReducerAction {
  type: OptionBuilderActionType;
  archivedOption?: boolean;
  defaultOption?: boolean;
  state?: OptionBuilderState;
}

export default function reducer(state: OptionBuilderState, action: OptionReducerAction): OptionBuilderState {
  switch (action.type) {
    case OptionBuilderActionType.resetAllValues:
      return {
        ...state,
        isArchivedChecked: false,
        isDefaultChecked: false,
        showAddNewModal: false,
      };
    case OptionBuilderActionType.editOption:
      if (isBoolean(action.defaultOption) && isBoolean(action.archivedOption)) {
        return {
          ...state,
          showAddNewModal: true,
          isDefaultChecked: action.defaultOption,
          isArchivedChecked: action.archivedOption,
        };
      }
      return { ...state };
    case OptionBuilderActionType.openAddNew:
      return {
        ...state,
        showAddNewModal: true,
        isDefaultChecked: false,
        isArchivedChecked: false,
      };
    case OptionBuilderActionType.updateDefaultProperty:
      if (isBoolean(action.defaultOption)) {
        return {
          ...state,
          isDefaultChecked: action.defaultOption,
        };
      }
      return { ...state };
    case OptionBuilderActionType.updateArchivedProperty:
      if (isBoolean(action.archivedOption)) {
        return {
          ...state,
          isDefaultChecked: action.archivedOption,
        };
      }
      return { ...state };
    default:
      return { ...state };
  }
}
